<div class="image-slider" #slider (wheel)="handleScroll($event)" *ngIf="payload.length" >
  <img class="image-slide" style="max-width: 100%;height: auto;display: inline-block;width: 210px;height: 160px;max-width: 210px;max-height: 160px;margin : 10px;" *ngFor="let elt of payload[crntDir].Payload;let i = index;" id="thumb_{{i}}" [src]="s3Uri + elt.file" [ngClass]="{'selected': i === index}" (click)="clickImage(i)">
  
</div>

